import _ from 'lodash';
import moment from 'moment';

import request from 'request';

import {
  Firebase,
  appConfig,
  callIfFunction,
  currentUserToken,
  logAndDispatchErrorForAction,
} from '../../util';

import {
  SAVE_DEAL,
  SAVE_DEAL_SUCCESS,
  SAVE_DEAL_ERROR,
} from '../types';

import { OrganizationRef, DealsRef, UsersRef } from '../../util/refs';

export function linkSalesforceDeal(dealId, salesforceDealId, callback){
  console.log('linkSalesforceDeal with: ', dealId, salesforceDealId);
  Firebase.auth().currentUser.getIdToken().then(authToken => {
    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/linkSalesforceDeal`,
      body: {
        dealId,
        salesforceDealId
      },
      json: true,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, body);
    });
  });
}
export function createSalesforceDeal(deal, callback){
  Firebase.auth().currentUser.getIdToken().then(authToken => {
    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/createSalesforceDeal`,
      body: deal,
      json: true,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, body);
    });
  });
}

//force reload of all salesforce data, ignoring last modified date
//(this can only be triggered by admins)
export function reloadSalesforceData(callback){
  Firebase.auth().currentUser.getIdToken().then(authToken => {
    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/reloadSalesforceData`,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, body);
    });
  });
}

export function refreshDealConfidenceCalculations(callback){
  Firebase.auth().currentUser.getIdToken().then(authToken => {
    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/refreshDealConfidenceCalculations`,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, body);
    });
  });
}

//sync recently modified objects
export function syncSalesforceData(callback){
  Firebase.auth().currentUser.getIdToken().then(authToken => {
    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/syncSalesforceData`,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, body);
    });
  });
}

//sync a specific salesforce opportunity
export function syncSalesforceDeal(dealId, callback){
  Firebase.auth().currentUser.getIdToken().then(authToken => {
    request({
      method: 'POST',
      uri: `${appConfig().API_URL}/syncSalesforceDeal`,
      body: { dealId },
      json: true,
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }, (err, resp, body) => {
      callIfFunction(callback, body);
    });
  });
}



// WEBPACK FOOTER //
// ./src/actions/integrations/salesforce.js